export default "__VITE_PUBLIC_ASSET__49e81f5d__"